<button
  (click)="handleData()"
  class="default-button primary-font-medium flex-center back-button flex-center"
  [class.rounded-pill]="theme() === GbTheme.ThemeOne"
  [class.back-button-t2]="theme() === GbTheme.ThemeTwo"
>
  @if (theme() === GbTheme.ThemeOne) {
    <app-arrow [svgClass]="'back-button-t1-arrow-icon'"></app-arrow>
  }

  @if (theme() === GbTheme.ThemeTwo) {
    <svg
      class="rtl"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
    >
      <path
        d="M6.59961 0.599609L0.599609 6.09961L6.59961 11.5996"
        stroke="black"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  }

  <span class="d-flex mt-xl-1"> {{ 'authentication.go_back_button' | translate }} </span>
</button>
